import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { CustomDialogBox } from '../../../../components/CustomDialogBox';
import useToggle from '../../../../hooks/useToggle';
import { getHealthScoreTrends } from '../../../../features/HealthScoreTrends/healthScoreTrendsAction';
import HealthScoreTrendsGraph from './HealthScoreTrendsGraph';

function HealthScoreTrendsDialog(props) {
  const {
    accountId, isShare, tenantId, accountOrgId, title, view, openGraph, setOpenGraph,
  } = props;

  const { error, loading, healthScoreTrendsData } = useSelector((state) => state.healthScoreTrends);
  const [refreshHealthScoreTrendData, setRefreshHealthScoreTrendData] = useToggle();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getHealthScoreTrends({
      accountId, view, isShare, tenantId, accountOrgId,
    }));
  }, [refreshHealthScoreTrendData, accountId, view, isShare, tenantId, accountOrgId]);

  return (
    openGraph ? (
      <CustomDialogBox
        title={title}
        open={openGraph}
        handleClose={setOpenGraph}
        actions
        content={(
          <HealthScoreTrendsGraph
            loading={loading}
            error={error}
            data={healthScoreTrendsData}
            refresh={setRefreshHealthScoreTrendData}
            message="No Data"
            viewOption={view}
          />
      )}
      />
    ) : null
  );
}

export default HealthScoreTrendsDialog;
